module.exports = __webpack_public_path__ + "static/Sushasan_yt_logo-16dfe0deb1207c2886aad0eaeebb1dc8.png";